import { actionConst } from './new-request.constants';
import { requestsConstants } from '../Requests/requests.constants';
import { authHeader, authUploadHeader } from '../../helpers/auth-header';
import { client } from '../../actions';
import { requestsActions } from '../Requests/requests.actions';
import bindCallToRequest from '../../requests/bindCallToRequest';
import request from '../../helpers/request';

const url = '/Request';

export const actions = {
	openNewRequestModal,
	closeNewRequestModal,
	fetchAddrStreetList,
	fetchAddServiceCompanyList,
	fetchAddrBuildingList,
	fetchServiceList,
	fetchWorkerList,
	fetchExecuterList,
	fetchSubserviceList,
	applyAddrStreet,
	applyAddrBuilding,
	applyAddrServiceCompany,
	applyAddrFlat,
	setAddrBuildingValue,
	setAddrFlatValue,
	setWorkerValue,
	setExecuterValue,
	setRequestId,
	applyService,
	resetService,
	applySubservice,
	applyPossWarranty,
	applyPossInternal,
	setServiceValue,
	setSubserviceValue,
	postRequest,
	resetPostedRequest,
	postCalendarEvent,
	setOwnerInfo,
	setOwnerData,
	resetTermOfExecution,
	retrieveLastState,
	clearApplicantList,
	fetchGetStagesLife,
	clearStagesLife,
  fetchGetOldRequests,
  clearOldRequests,
  fetchGetHintsByRequestType,
  clearHintsByRequestType,
  fetchHintsByServiceCompany,
  clearHintsByServiceCompany,
  fetchShowHintsAndOldRequests,
	fetchApplyAddressByPhone
};

function setOwnerInfo(val) {
	return dispatch => {
		localStorage.setItem('dspxOwnerInfo', JSON.stringify(val));
		dispatch({
			type: actionConst.SET_OWNER_INFO,
			payload: val
		})
	}
}

function resetPostedRequest() {
	return dispatch => {
		dispatch({
			type: actionConst.RESET_POSTED_REQUEST,
		})
	}
}

function postAttachments(reqn, attach) {

	let rurl = url + '/add_file/' + reqn;

	return dispatch => {

		client.post(rurl, attach, { headers: authUploadHeader() })
			.then(response => {
				console.log(response);
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function bindCall(callId, requestId) {
	return async () => {
		await bindCallToRequest({ callId, requestId })
	}
}

function postCalendarEvent(data) {

	let rurl = url + '/add_task';

	return client.post(rurl, data, { headers: authHeader() })
}

function postRequest(value, attachments, callId) {
	return dispatch => {
		let rurl = url;

		client.post(rurl, value, { headers: authHeader() })
			.then(function (response) {
				const nr = response.data;
				dispatch({
					type: actionConst.POST_REQUEST,
					payload: nr
				})				

				if (attachments.length > 0) {
					new Promise((resolve, reject) => {
						attachments.forEach((file) => {
							const formData = new FormData();
							formData.append('file', file);
							dispatch(postAttachments(nr, formData));
						});
						resolve()
					}).then(() => {
						dispatch(requestsActions.fetchRequests(nr, undefined, false));
					})
				}

				if (callId) {
					new Promise((resolve, reject) => {
						dispatch(bindCall(callId, +nr));
						resolve()
					}).then(() => {
						dispatch(requestsActions.fetchRequests(nr, undefined, false));
					})
				}

				dispatch(requestsActions.fetchRequests(nr, undefined, false));	
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function applyAddrStreet(value) {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_ADDR_STREET,
			payload: value
		})

		const { requestId } = getState().newRequestStore

		dispatch(hidePossWarranty());
		dispatch(changeInternal());
		dispatch(fetchAddrBuildingList(value));
		dispatch(fetchAddrFlatList(undefined));
		dispatch(fetchServiceList(undefined));
		dispatch(fetchSubserviceList({}));
		dispatch(fetchWorkerList({ requestId }));
		dispatch(fetchExecuterList({ requestId }));

		dispatch(setAddrBuildingValue(undefined));
		dispatch(setAddrFlatValue(undefined));
		//dispatch(setServiceValue(undefined));
		//dispatch(setSubserviceValue(undefined));
		//dispatch(setWorkerValue(undefined));
		//dispatch(setExecuterValue(undefined));
	}
}


function applyAddrServiceCompany(value) {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_ADDR_SERVICE_COMPANY,
			payload: value
		})
		dispatch(fetchAddrStreetList(value))
	}
}

function applyAddrBuilding(value, serviceId) {
	return (dispatch, getState) => {
		const { requestId } = getState().newRequestStore

		dispatch(hidePossWarranty());
		dispatch(changeInternal());
		dispatch(fetchAddrFlatList(value));
		dispatch(fetchServiceList({houseId: value}));
		dispatch(fetchSubserviceList({}));
		dispatch(fetchWorkerList({houseId: value, requestId, serviceId}));
		dispatch(fetchExecuterList({houseId: value, requestId, serviceId}));

		dispatch(setAddrBuildingValue(value));
		dispatch(setAddrFlatValue(undefined));
		//dispatch(setServiceValue(undefined));
		//dispatch(setSubserviceValue(undefined));
		//dispatch(setWorkerValue(undefined));
		//dispatch(setExecuterValue(undefined));
	}
}

function applyAddrFlat(value) {
  return async (dispatch, getState) => {
    dispatch(fetchWorkerList({ addressId: value }));
    dispatch(fetchExecuterList({ addressId: value }));
		if(!!value) {
			dispatch(fetchApplicantList(value));
		}

    dispatch(setAddrFlatValue(value));
    dispatch(setWorkerValue(undefined));
    dispatch(setExecuterValue(undefined));

    const { valueSubservice, termOfExecution } = getState().newRequestStore;

    if (value && valueSubservice) {
      const termOfExecution = await getTermOfExecution({
        serviceId: valueSubservice,
        addressId: value,
      });

      dispatch(setTermOfExecution(termOfExecution));
    } else if (termOfExecution) {
      dispatch(resetTermOfExecution());
    }
  };
}

function setSubserviceValue(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_SUBSERVICE_VALUE,
			payload: value
		})
	}
}

function setServiceValue(value) {
		return dispatch => {
			dispatch({
				type: actionConst.APPLY_SERVICE,
				payload: value
			})	
	}
}

function setAddrBuildingValue(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_ADDR_BUILDING_VALUE,
			payload: value
		})
	}
}

function setAddrFlatValue(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_ADDR_FLAT_VALUE,
			payload: value
		})
	}
}

function setRequestId(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_REQUEST_ID,
			payload: value,
		})
	}
}

function setWorkerValue(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_WORKER_VALUE,
			payload: value
		})
	}
}

function setExecuterValue(value) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_EXECUTER_VALUE,
			payload: value
		})
	}
}

function setOwnerData(name, phone) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_OWNER_DATA,
			payload: [name, phone]
		})
	}
}

function fetchSubserviceList({service,building,subService}) {

	return service ? async (dispatch, getState) => {

		const buildingId = building || getState().newRequestStore.valueAddrBuilding || 0

		let rurl = url + `/services?parentIds=${service}&houseId=${buildingId}` 

		try {
		const response  = await client.get(rurl, { headers: authHeader() })


		dispatch({
			type: actionConst.FETCH_SUBSERVICE_REF,
			payload: {value: response, subService}
		})

		const { valueSubservice, listSubservice } = getState().newRequestStore
		const sl = response.data
		const selected = sl && sl.some(e => e.id == valueSubservice)

		if(selected) {
			const show = await allowPossWarranty({serviceId: valueSubservice, buildingId})
			dispatch({
				type: actionConst.SET_SHOW_POSS_WARRANTY,
				payload: show,
			})
		}
		} catch (e) {
			dispatch({
			type: actionConst.FETCH_SUBSERVICE_REF,
			payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
		})
		}

	} : dispatch => {
		dispatch({
			type: actionConst.FETCH_SUBSERVICE_REF,
			payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
		})
	}
}

function fetchApplyAddressByPhone(value) {
  const { companyId, phone } = value;

  return dispatch => {
    if (!companyId || !phone) {
      dispatch({
        type: actionConst.FETCH_APPLY_ADDRESS_BY_PHONE_REF,
        payload: Promise.resolve({ data: [] }),
      });

      return Promise.resolve();
    }

    const rurl = url + `/address_by_phone?companyId=${companyId}&phone=${phone}`;

    const request = client.get(rurl, { headers: authHeader() });

    dispatch({
      type: actionConst.FETCH_APPLY_ADDRESS_BY_PHONE_REF,
      payload: request,
    });

    return request;
  };
}

function fetchAddrBuildingList(street) {

	return street ? dispatch => {

		let rurl = url + '/houses';
		if (street && !isNaN(street)) rurl += '/' + street;
	
		dispatch({
			type: actionConst.FETCH_ADDR_BUILDING_REF,
			payload: client.get(rurl, { headers: authHeader() })
		})
	} : dispatch => {
		dispatch({
			type: actionConst.FETCH_ADDR_BUILDING_REF,
			payload: new Promise((resolve, reject) => { resolve({ data: [] }); })
		})
	}
}

function fetchAddrFlatList(building) {

	let rurl = url + '/house_flats';
	if (building && !isNaN(building)) rurl += '/' + building;

	return dispatch => {
		dispatch({
			type: actionConst.FETCH_ADDR_FLAT_REF,
			payload: building ? client.get(rurl, { headers: authHeader() }) : new Promise((resolve, reject) => { resolve({ data: [] }); })
		})
	}
}

async function allowPossWarranty({serviceId, buildingId}) {
		try {
			const data = (await client.get(`${url}/check_warranty?serviceId=${serviceId}&houseId=${buildingId}`,
				{ headers: authHeader() })).data
				return data && data.isWarranty
		} catch(e)	{
			console.log('**** checkPossWarranty')
			console.log(e)
		}
		return false
}

async function allowPossInternal({serviceId, buildingId}) {
	try {
		const data = (await client.get(`${url}/check_internal?serviceId=${serviceId}&houseId=${buildingId}`,
			{ headers: authHeader() })).data
			return data && data.isInternal
	} catch(e)	{
		console.log(e)
	}
	return false
}

function applyService(value) {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_SERVICE,
			payload: value
		})
		const { requestId } = getState().newRequestStore

		dispatch(hidePossWarranty());
		dispatch(changeInternal());

		dispatch(fetchSubserviceList({service:value}));
		dispatch(fetchWorkerList({requestId}));
		dispatch(fetchExecuterList({requestId}));

		//dispatch(setSubserviceValue(undefined));
		//dispatch(setWorkerValue(undefined));
		//dispatch(setExecuterValue(undefined));
	}
}

function resetService(value) {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_SERVICE,
			payload: value?.valueService
		})
		const { requestId } = getState().newRequestStore

		dispatch(hidePossWarranty());
		dispatch(changeInternal());

		dispatch(fetchSubserviceList({service:value?.valueService, subService: value?.valueSubservice}));
		dispatch(fetchWorkerList({requestId, valueWorker: value?.valueWorker}));
		dispatch(fetchExecuterList({requestId, valueExecuter: value?.valueExecuter}));
	}
}

function applySubservice(value) {
  return async (dispatch, getState) => {
    const { valueAddrBuilding, valueAddrFlat, termOfExecution } =
      getState().newRequestStore;

    const show = await allowPossWarranty({
      serviceId: value,
      buildingId: valueAddrBuilding,
    });
    dispatch({
      type: actionConst.SET_SHOW_POSS_WARRANTY,
      payload: show,
    });
		const showInternal = await allowPossInternal({
			serviceId: value,
			buildingId: valueAddrBuilding,
		});

    dispatch(setSubserviceValue(value));
    dispatch(applyPossWarranty(show));
		dispatch(applyPossInternal(showInternal));

    if (value && valueAddrFlat) {
      const termOfExecution = await getTermOfExecution({
        serviceId: value,
        addressId: valueAddrFlat,
      });

      dispatch(setTermOfExecution(termOfExecution));
    } else if (termOfExecution) {
      dispatch(resetTermOfExecution());
    }
  };
}

function hidePossWarranty () {
	return (dispatch,getState) => {
		dispatch({
			type: actionConst.SET_SHOW_POSS_WARRANTY,
			payload: false,
		})
		dispatch({
			type: actionConst.APPLY_POSS_WARRANTY,
			payload: false,
		})
		/*const { valueService, valueAddrBuilding } = getState().newRequestStore
		if(valueAddrBuilding) {
			dispatch(fetchWorkerList({serviceId: valueService, houseId: valueAddrBuilding}));
			dispatch(fetchExecuterList({serviceId: valueService, houseId: valueAddrBuilding}));
		}*/
	}
}

function changeInternal() {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_POSS_INTERNAL,
			payload: false,
		})
	}
}

function applyPossWarranty(possWarranty) {
	return (dispatch,getState) => {
		dispatch({
			type: actionConst.APPLY_POSS_WARRANTY,
			payload: possWarranty,
		})

		const { valueSubservice, valueAddrBuilding, valueAddrFlat } = getState().newRequestStore
		if(valueAddrBuilding) {
			dispatch(fetchWorkerList({serviceId: valueSubservice, houseId: valueAddrBuilding, addressId: valueAddrFlat, possWarranty}));
			dispatch(fetchExecuterList({serviceId: valueSubservice, houseId: valueAddrBuilding, addressId: valueAddrFlat, possWarranty}));
		}
	}
}

function applyPossInternal(possInternal) {
	return (dispatch, getState) => {
		dispatch({
			type: actionConst.APPLY_POSS_INTERNAL,
			payload: possInternal,
		})
	}
}

function fetchExecuterList(param) {
	return param ? async (dispatch, getState) => {



	const { valueSubservice, valueAddrBuilding, valueAddrFlat, valuePossWarranty, requestId } = getState().newRequestStore
	let rurl = url + '/executers?houseId='+ (param.houseId ? param.houseId : (valueAddrBuilding ? valueAddrBuilding : 0)) + '&addressId=' + (param.addressId ? param.addressId : (valueAddrFlat ? valueAddrFlat : 0)) + '&serviceId=' + (param.serviceId ? param.serviceId : (valueSubservice ? valueSubservice : 0)) + '&requestId=' + (param.requestId ? param.requestId : (requestId ? requestId : 0)) +'&isWarranty=' + (param.possWarranty || valuePossWarranty)
				try {
	const response  = await client.get(rurl, { headers: authHeader() });

	dispatch({
			type: actionConst.FETCH_EXECUTER_REF,
			payload: {value: response, valueExecuter: param?.valueExecuter}
		})
		} catch (e) {
			dispatch({
			type: actionConst.FETCH_EXECUTER_REF,
			payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
		})
		}
	} : dispatch => {
		dispatch({
			type: actionConst.FETCH_EXECUTER_REF,
			payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
		})
	}
}

function fetchWorkerList(param) {
	return param ? async (dispatch, getState) => {

		const { valueSubservice, valueAddrBuilding, valueAddrFlat, valuePossWarranty, requestId } = getState().newRequestStore
		let rurl = url + '/workers?houseId='+ (param.houseId ? param.houseId : (valueAddrBuilding ? valueAddrBuilding : 0)) + '&addressId=' + (param.addressId ? param.addressId : (valueAddrFlat ? valueAddrFlat : 0)) + '&serviceId=' + (param.serviceId ? param.serviceId : (valueSubservice ? valueSubservice : 0)) + '&requestId=' + (param.requestId ? param.requestId : (requestId ? requestId : 0)) +'&isWarranty=' + (param.possWarranty || valuePossWarranty)
		try {
			const response  = await client.get(rurl, { headers: authHeader() });

			dispatch({
				type: actionConst.FETCH_WORKER_REF,
				payload: {value: response, valueWorker: param?.valueWorker}
			})
		} catch (e) {
			dispatch({
						type: actionConst.FETCH_WORKER_REF,
						payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
					})
		}
	} : dispatch => {
		dispatch({
			type: actionConst.FETCH_WORKER_REF,
			payload: new Promise((resolve, reject) => { resolve({ value: {data: []} }); })
		})
	}
}

function fetchServiceList(param) {
	return param ? (dispatch, getState) => {
	const { valueService } = param.serviceId ? param.serviceId : getState().newRequestStore	
	const rurl = url + '/parent_services?houseId=' + (param.houseId ? param.houseId : 0)
	const serviceList = client.get(rurl, { headers: authHeader() })
	serviceList.then(response => {
		const l = response.data
		if(l && l.some(e => e.id == valueService)){
			dispatch(fetchSubserviceList({
				service:valueService,
				building:param.houseId ? param.houseId : 0
			}));
		}
	})
	dispatch({
			type: actionConst.FETCH_SERVICE_REF,
			payload: serviceList
		})
} : dispatch => {
	dispatch({
		type: actionConst.FETCH_SERVICE_REF,
		payload: new Promise((resolve, reject) => { resolve({ data: [] }); })
	})
}
}

function fetchAddrStreetList(companyId) {
	let rurl = url + '/streets';

	let rurlByCompany = `${url}/service_companies_streets?serviceCompanyIds=${companyId || 0}`;

	return dispatch => {

		dispatch({
			type: actionConst.FETCH_ADDR_STREET_REF,
			payload: client.get(companyId ? rurlByCompany : rurl, { headers: authHeader() })
		})
	}
}


function fetchAddServiceCompanyList() {

	let rurl = url + '/companies';

	return dispatch => {

		dispatch({
			type: actionConst.FETCH_ADDR_SERVICE_COMPANY,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}


function fetchApplicantList(value) {
	return (dispatch) => {	
		dispatch({
			type: actionConst.SET_APPLICANT,
			payload: value ? request.get(`/HousingStock/address/${value}/clients`, {}, 'Не удалось загрузить заявителей', []) : []
		})
	}
}

function fetchGetStagesLife(value) {
	return (dispatch) => {	
		dispatch({
			type: actionConst.SET_STAGE_LIFE,
			payload: request.get(`Request/get_request_address_stage_life_cycle`, {
				addressId: value,
			}, 'Не удалось получить стадию жизненного цикла помещения', []) 
		})
	}
}

function clearStagesLife () {
	return (dispatch) => {	
		dispatch({
			type: actionConst.CLEAR_STAGE_LIFE,
		})
	}
}

function fetchGetOldRequests(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_OLD_REQUESTS,
      payload: request.get(`Request/get_old_requests`, {
				addressId: value,
			}, 'Не удалось получить старые заявки', []) 
		})
  }
}

function clearOldRequests() {
  return (dispatch) => {
    dispatch({
      type: actionConst.CLEAR_OLD_REQUESTS
    })
  }
}

function fetchGetHintsByRequestType({ houseId, typeId }) {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_HINTS_BY_REQUEST_TYPE,
      payload: request.get(`Request/get_hints_by_request_type`, {
        houseId,
        typeId,
      })
    })
  }
}

function clearHintsByRequestType() {
  return (dispatch) => {
    dispatch({
      type: actionConst.CLEAR_HINTS_BY_REQUEST_TYPE
    })
  }
}

function fetchHintsByServiceCompany({ houseId }) {
  return (dispatch) => {
    dispatch({
    type: actionConst.SET_HINTS_BY_SERVICE_COMPANY,
    payload: request.get(`Request/get_hints_by_service_company`, {
        houseId
      })
    })
  }
}

function clearHintsByServiceCompany() {
  return (dispatch) => {
    dispatch({
      type: actionConst.CLEAR_HINTS_BY_SERVICE_COMPANY,
    })
  }
}

function fetchShowHintsAndOldRequests() {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_SHOW_HINTS_AND_OLD_REQUESTS,
      payload: request.get(`/Request/get_show_hints_and_old_requests`)
    })
  }
}

function clearApplicantList() {
	return (dispatch) => {	
		dispatch({type: actionConst.CLEAR_APPLICANT})
	}
}

function fetchCreationMethodList() {

	let rurl = url + '/creation_methods';

	return dispatch => {
		dispatch({
			type: actionConst.FETCH_CREATION_METHOD_REF,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function openNewRequestModal(r) {
	return dispatch => {
		dispatch({			
			type: actionConst.OPEN_NEW_REQUEST_MODAL,
			payload: r
		})
	}
}

function closeNewRequestModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_NEW_REQUEST_MODAL
		})
	}
}

async function getTermOfExecution({ serviceId, addressId }) {
  if (!serviceId || !addressId) return;

  const termOfExecution = await request.get(
    '/Request/term_of_execution',
    { serviceId, addressId },
    'Не удалось загрузить дату назначения по умолчанию',
  );

	return termOfExecution.executeDate;
}

function setTermOfExecution(date) {
	return dispatch => {
		dispatch({
			type: actionConst.SET_TERM_OF_EXECUTION,
			payload: date
		})
	}
}

function resetTermOfExecution() {
	return dispatch => {
		dispatch({
			type: actionConst.RESET_TERM_OF_EXECUTION,
		})
	}
}

function retrieveLastState(state) {
	return dispatch => {
		dispatch({
			type: actionConst.RETRIEVE_LAST_STATE,
			payload: state
		})
	}
}